module.exports = __webpack_public_path__ + "static/img/0104_00.8af221a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/0104_00.png
// module id = yw5y
// module chunks = 1